import styled from "styled-components";
import React, { useEffect, useState } from "react";
import { InputTitle } from "../inputs/InputTitle";
import { TextBtn } from "../inputs/TextBtn";
import { gql, useApolloClient, useMutation } from "@apollo/client";
import { Documents_Query } from "../../pages/Work/WorkPageDocuments";

const StyleCss = styled.div`
    margin: 1rem;
    padding: 1rem;
    border: 1px solid lightgray;
    border-radius: 8px;
    .green {
        background-color: var(--error-bg);
    }
    .yellow {
        background-color: var(--error-bg-yellow);
    }
    .red {
        background-color: var(--error-bg-red);
    }
    .data {
        display: flex;
        gap: 1rem;
        .left {
            width: 50%;
            aspect-ratio: 2;
            background-color: aliceblue;
            border-radius: 4px;
            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
                display: block;
            }
        }
        .right {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            .status {
                border-radius: 4px;
                padding: 1rem;
            }
            .selectbtn {
                width: 50%;
            }
            .expand {
                flex-grow: 1;
            }
        }
    }
`

const AddOrEditDocument_Mutation = gql`
  mutation AddOrEditDocument(
    $tag: String!
    $File: Upload!
  ){
    addOrEditDocument(tag: $tag, File: $File){
        status
    }
  }
`
export function CardMeliUpload(props) {
    const type = props.type;
    const client = useApolloClient();
    const [image, setImage] = useState("");
    const [file, setFile] = useState("");
    const [CDataQuery, { loading }] = useMutation(
        AddOrEditDocument_Mutation,
        {
          onCompleted: proccessData,
        }
    );
    useEffect(() => {
        if(props.data){
            let find = props.data.find((v) => v.tag === type);
            if(find){
                setImage(find);
            }
        }
    }, [props.data])
    function proccessData(newData) {
        if (newData.addOrEditDocument.status) {
          props.updateError({
              text: 'Saved successfully',
              time: 3,
              type: 'confirm'
          });
          client.refetchQueries({include: [Documents_Query]})
        }
    }
    function sendData() {
        if(file === ""){
            return;
        }
        CDataQuery({
            variables: {
              tag: type,
              File: file
            },
          });
    }
    const checkData = () => {
        if (
            file !== ""
        ) {
          return true;
        } else {
          return false;
        }
    };
    const onChange = (event) => {
        switch (event.target.name) {
            case 'filecard':
                setFile(event.target.files[0]);
                break;
            default: 
                break;
        }
    }
    const statusMake = (e) => {
        switch(e){
            case 1:
                return "file added waiting for confirmation"
            case 2:
                return "file confirmed"
            default:
                return ""
        }
    }
    const makeStatusColor = (e) => {
        switch(e){
          case 1:
              return "yellow"
          case 2:
              return "green"
          case -1:
              return "red"
          default:
              return ""
        }
    }
    return (
        <StyleCss>
            <InputTitle>{props.title}</InputTitle>
            <div className="data">
                <div className="left">
                    {
                        (image !== "")? (
                            <img src={image.Address} alt={type}/>
                        ) : ""
                    }
                </div>
                <div className="right">
                    <div className={"status" + " " + makeStatusColor(image.status)}>{statusMake(image.status)}</div>
                    <div className="desc">{image.description}</div>
                    <div className="expand"></div>
                    <div>upload new file</div>
                    <div className={"select"}>
                        <input type="file" name="filecard" accept="image/*" onChange={onChange}/>
                    </div>
                    <div className={"selectbtn"}>
                        <TextBtn
                            text={"Send"}
                            type={"submit"}
                            onclick={sendData}
                            loading={loading}
                            disabled={!checkData() || loading}
                        />
                    </div>
                </div>
            </div>
        </StyleCss>
    )
}